import React, { useState, useContext, useEffect } from 'react';

import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import FormControl from '@mui/material/FormControl';
import { collection, onSnapshot, query } from 'firebase/firestore';

import { LocationContext } from '../LocationContext';
import { db } from '../firebase';
import { CartContext } from '../CartContext';


export const useLocations = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(query(collection(db, 'locations')), (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ ...doc.data(), id: doc.id });
      });
      setLocations(list);
    });

    return () => unsubscribe();
  }, []);

  return locations;
}

export default function LocationSelect() {
  const locations = useLocations();
  const cart = useContext(CartContext);
  const { ticketLocation, setTicketLocation } = useContext(LocationContext);

  const handleChange = (event) => {
    const { value: id } = event.target;
    const location = locations.find((location) => location.id === id);
 
    cart.clearCart();
    setTicketLocation({
      id,
      name: location.name,
      hours: location.hours,
      timeZone: location.timeZone
    })
  };

  return (
    <FormControl fullWidth={true}>
      <ButtonGroup fullWidth={true}>
        {
          locations.sort((a,b) => b.name.localeCompare(a.name)).map((location) => (
            <Button
              sx={{px: 1, fontSize: '0.625rem', fontWeight: 'bold'}}
              variant={location.id === ticketLocation?.id ? 'contained' : 'outlined'}
              key={location.id}
              onClick={() => handleChange({ target: { value: location.id } })}>
              {location.name}
            </Button>
          ))
        }
      </ButtonGroup>
    </FormControl>
  );
}